// Thin wrapper so components can be unit-tested without touching
// window.location (non-configurable in jsdom).
export const reloadPage = (): void => {
    window.location.reload();
};
